import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { simInfoColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getSimInfo } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "status", "iccid", "last_updated"];

const NyxSimInfoBatch = () => (
  <BatchDetail
    title="Sim Info"
    apiGet={__getSimInfo}
    client={CLIENTS.nyx}
    columnsFactory={simInfoColumns}
    copyKeys={COPY_KEYS}
    exportAction="sim_info"
    showTerminate
    terminateOperation="sim_info"
  />
);

export default NyxSimInfoBatch;
